import apiHttpClient from "./ApiHttpService";

export default class EmployeeMobileDeviceService {
  getEmployeeMobileDevice(deviceId) {
    return apiHttpClient.get(
      "trs/mobile/EmployeeMobileDevice/getEmployeeMobileDevice?deviceId=" +
        deviceId
    );
  }
  registerDeviceId(deviceId) {
    return apiHttpClient.post(
      "trs/mobile/EmployeeMobileDevice/registerDeviceId?deviceId=" + deviceId,
      {}
    );
  }
}
